// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomApps_wrapper__1Aq65","link-text":"CustomApps_link-text__3U7Ao","selectWrapper":"CustomApps_selectWrapper__Nmg5h"};